/* Golden Outlet — ajout rapide par pointure sur les cartes produit */
if (!customElements.get('go-quick-sizes')) {
  customElements.define('go-quick-sizes', class GoQuickSizes extends HTMLElement {
    connectedCallback() {
      var card = this.closest('.card');
      var inner = card && card.querySelector('.card__inner');
      if (card && inner && this.parentNode !== card) { card.appendChild(this); return; }
      if (this.ready) return;
      this.ready = true;
      if (card && inner) {
        card.classList.add('go-qs-host');
        var me = this;
        var sync = function () { me.style.top = inner.offsetTop + 'px'; me.style.height = inner.offsetHeight + 'px'; };
        sync();
        if (window.ResizeObserver) new ResizeObserver(sync).observe(inner); else window.addEventListener('resize', sync);
      }
      this.toggleBtn = this.querySelector('.go-qs__toggle');
      this.msgEl = this.querySelector('.go-qs__msg');
      var self = this;
      this.toggleBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.setOpen(!self.classList.contains('is-open')); });
      this.addEventListener('click', function (e) {
        var b = e.target.closest('.go-qs__size');
        if (!b) return;
        e.preventDefault(); e.stopPropagation();
        if (!b.disabled) self.add(b);
      });
      this.addEventListener('keydown', function (e) { if (e.key === 'Escape') { self.setOpen(false); self.toggleBtn.focus(); } });
      this.outside = function (e) { if (!self.contains(e.target)) self.setOpen(false); };
    }
    setOpen(open) {
      this.classList.toggle('is-open', open);
      this.toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { document.addEventListener('click', this.outside); var f = this.querySelector('.go-qs__size:not([disabled])'); if (f) f.focus({ preventScroll: true }); }
      else document.removeEventListener('click', this.outside);
    }
    say(text) { if (!this.msgEl) return; this.msgEl.textContent = text || ''; this.msgEl.hidden = !text; }
    add(btn) {
      if (this.busy) return;
      this.busy = true; this.say('');
      btn.classList.add('is-loading');
      var self = this;
      var routes = window.routes || { cart_add_url: '/cart/add', cart_url: '/cart' };
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      var body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
      if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
      fetch(routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { self.say(res.description || res.message || 'Ajout impossible pour le moment.'); return; }
          btn.classList.add('is-added');
          if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'go-quick-sizes', productVariantId: btn.dataset.variantId, cartData: res });
          self.setOpen(false);
          if (drawer && drawer.renderContents && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
          else window.location.href = routes.cart_url;
        })
        .catch(function () { self.say('Connexion impossible, réessayez.'); })
        .finally(function () { self.busy = false; btn.classList.remove('is-loading'); setTimeout(function () { btn.classList.remove('is-added'); }, 1800); });
    }
  });
}
